module.exports = __webpack_public_path__ + "images/d5da8f8a6e4d76d9f3c34eaa2d433eb0.gif";